export default "__VITE_ASSET__ChAU0ZJ4__"